export default function test(str) {
    if (!str) return true;
    return isFinite(str) && Math.abs(str) <= 90;
}